import React, { PropsWithChildren, createContext } from "react";

type State = {
  ladyId: string | undefined;
};

const LolcalLadyIdContext = createContext<State | null>(null);

export const LocalLadyIdContextProvider: React.FC<
  PropsWithChildren & State
> = ({ children, ladyId }) => {
  return (
    <LolcalLadyIdContext.Provider value={{ ladyId }}>
      {children}
    </LolcalLadyIdContext.Provider>
  );
};

export const useLocalLadyIdContext = () => {
  const context = React.useContext(LolcalLadyIdContext);

  return context?.ladyId;
};
